// AUTO-GENERATED from device/third_party/Ani-Emo-Eye/Display_Emotion/eyes.h
export const ANI_EMO_EYE_META = { width: 128, height: 64 }
export const ANI_EMO_EYE_FRAMES = {
  eye0: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye1: [
    7,255,255,224,31,255,255,248,63,255,255,252,127,255,255,254,127,255,255,254,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,127,255,255,254,127,255,255,254,63,255,255,252,
    31,255,255,248,7,255,255,224,
  ],
  eye2: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,127,254,0,1,255,255,128,
    3,255,255,192,7,255,255,224,7,255,255,224,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,
    7,255,255,224,3,255,255,192,1,255,255,128,0,127,254,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye3: [
    0,127,254,0,1,255,255,128,3,255,255,192,7,255,255,224,7,255,255,224,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,7,255,255,224,3,255,255,192,
    1,255,255,128,0,127,254,0,
  ],
  eye4: [
    7,255,255,224,31,255,255,248,63,255,255,252,127,255,255,254,127,255,255,254,255,255,255,255,
    255,255,255,255,248,0,0,31,224,0,0,7,192,0,0,3,128,0,0,1,128,0,0,1,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye5: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,127,254,0,1,255,255,128,
    3,255,255,192,7,255,255,224,7,255,255,224,15,255,255,240,15,128,1,240,14,0,0,112,
    12,0,0,48,8,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye6: [
    0,127,254,0,1,255,255,128,3,255,255,192,7,255,255,224,7,255,255,224,15,255,255,240,
    15,128,1,240,14,0,0,112,12,0,0,48,8,0,0,16,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye7: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,127,255,255,254,127,255,255,254,63,255,255,252,
    31,255,255,248,7,255,255,224,
  ],
  eye8: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,
    7,255,255,224,3,255,255,192,1,255,255,128,0,127,254,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye9: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,7,255,255,224,3,255,255,192,
    1,255,255,128,0,127,254,0,
  ],
  eye10d: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,248,0,0,0,
    255,0,0,0,255,224,0,0,255,252,0,0,255,255,128,0,255,255,240,0,255,127,254,0,
    255,255,255,192,255,255,255,248,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,127,255,255,254,127,255,255,254,63,255,255,252,
    31,255,255,248,7,255,255,224,
  ],
  eye10i: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,31,
    0,0,0,255,0,0,7,255,0,0,63,255,0,1,255,255,0,15,255,255,0,127,255,255,
    3,255,255,255,31,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,127,255,255,254,127,255,255,254,63,255,255,252,
    31,255,255,248,7,255,255,224,
  ],
  eye11d: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,6,0,0,0,7,192,0,0,15,248,0,0,15,255,0,0,15,255,224,0,
    15,255,252,0,15,255,255,128,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,
    7,255,255,224,3,255,255,192,1,255,255,128,0,127,254,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye11i: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,96,0,0,3,224,0,0,31,240,0,0,255,240,0,7,255,240,
    0,63,255,240,1,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,
    7,255,255,224,3,255,255,192,1,255,255,128,0,127,254,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye12d: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,6,0,0,0,7,192,0,0,15,248,0,0,15,255,0,0,15,255,224,0,
    15,255,252,0,15,255,255,128,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,7,255,255,224,3,255,255,192,
    1,255,255,128,0,127,254,0,
  ],
  eye12i: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,96,0,0,3,224,0,0,31,240,0,0,255,240,0,7,255,240,
    0,63,255,240,1,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,7,255,255,224,3,255,255,192,
    1,255,255,128,0,127,254,0,
  ],
  eye13d: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,31,0,0,0,255,0,0,7,255,
    0,0,63,255,0,1,255,255,0,15,255,255,0,127,255,255,3,255,255,255,31,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,127,255,255,254,127,255,255,254,63,255,255,252,
    31,255,255,248,7,255,255,224,
  ],
  eye13i: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,64,0,0,0,248,0,0,0,255,0,0,0,255,224,0,0,
    255,252,0,0,255,255,128,0,255,255,240,0,255,127,254,0,255,255,255,192,255,255,255,248,
    255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,
    255,255,255,255,255,255,255,255,255,255,255,255,127,255,255,254,127,255,255,254,63,255,255,252,
    31,255,255,248,7,255,255,224,
  ],
  eye14d: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,96,
    0,0,3,224,0,0,31,240,0,0,255,240,0,7,255,240,0,63,255,240,1,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,
    7,255,255,224,3,255,255,192,1,255,255,128,0,127,254,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye14i: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,0,0,
    7,192,0,0,15,248,0,0,15,255,0,0,15,255,224,0,15,255,252,0,15,255,255,128,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,
    7,255,255,224,3,255,255,192,1,255,255,128,0,127,254,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye15d: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,96,
    0,0,3,224,0,0,31,240,0,0,255,240,0,7,255,240,0,63,255,240,1,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,7,255,255,224,3,255,255,192,
    1,255,255,128,0,127,254,0,
  ],
  eye15i: [
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,0,0,0,
    7,192,0,0,15,248,0,0,15,255,0,0,15,255,224,0,15,255,252,0,15,255,255,128,
    15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,15,255,255,240,
    15,255,255,240,15,255,255,240,15,255,255,240,7,255,255,224,7,255,255,224,3,255,255,192,
    1,255,255,128,0,127,254,0,
  ],
  eye16d: [
    0,0,0,0,0,0,0,0,0,0,0,0,7,240,15,192,15,252,63,240,31,254,127,248,
    63,255,255,248,63,255,255,252,63,255,255,252,127,255,255,252,127,255,255,252,63,255,255,252,
    63,255,255,252,63,255,255,252,31,255,255,248,31,255,255,248,15,255,255,240,7,255,255,224,
    7,255,255,192,1,255,255,128,0,255,255,0,0,127,254,0,0,63,252,0,0,31,248,0,
    0,15,240,0,0,7,224,0,0,3,192,0,0,1,128,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
  eye16i: [
    0,0,0,0,0,0,0,0,0,0,0,0,7,240,15,192,15,252,63,240,31,254,127,248,
    63,255,255,248,63,255,255,252,63,255,255,252,127,255,255,252,127,255,255,252,63,255,255,252,
    63,255,255,252,63,255,255,252,31,255,255,248,31,255,255,248,15,255,255,240,7,255,255,224,
    7,255,255,192,1,255,255,128,0,255,255,0,0,127,254,0,0,63,252,0,0,31,248,0,
    0,15,240,0,0,7,224,0,0,3,192,0,0,1,128,0,0,0,0,0,0,0,0,0,
    0,0,0,0,0,0,0,0,
  ],
}
